<template>
  <v-container fluid fill-height class="mt-16">
    <v-alert type="error" v-if="isOldBrowser" class="mb-5" style="width: 100%">
      <br />
      Du verkar använda en föråldrad version av webbläsare! <br />
      Vi rekommenderar Google Chrome för bästa upplevelse.
      <br /><br />
    </v-alert>

    <h1 v-if="!isOldBrowser">{{ $t('vendors.upload.uploadImages') }}</h1>
    <v-row fill-height v-if="!isOldBrowser">
      <v-col fill-height class="my-3">
        <!--UPLOAD-->
        <form
          enctype="multipart/form-data"
          novalidate
          v-if="isInitial || isSaving"
          class="fill-height dropbox d-flex justify-center"
        >
          <input
            type="file"
            multiple
            ref="fileElement"
            v-if="!uploadError"
            :name="uploadFieldName"
            :disabled="isSaving"
            @change="
              filesChange($event.target.name, $event.target.files);
              fileCount = $event.target.files.length;
            "
            accept="image/*"
            class="input-file fill-height"
          />

          <p v-if="isInitial" class="d-flex justify-center align-center text-h5">
            {{ $t('vendors.upload.dragDropText') }}
          </p>
          <p v-if="isInitial" class="d-flex justify-center align-center">
            <i>{{ $t('vendors.upload.imageSizeText') }}</i>
          </p>
          <p v-if="isSaving" class="d-flex justify-center align-end">
            {{ $t('vendors.upload.uploadingImages', { fileCount }) }}
          </p>
          <div class="progress-bar-container" v-if="isSaving">
            <v-progress-linear v-model="progressValue"></v-progress-linear>
          </div>
          <p
            class="d-flex justify-center align-center red--text"
            v-if="fileSizeError"
            v-html="$t('vendors.upload.fileSizeWarning')"
          ></p>
          <p class="red--text pt-5" v-if="uploadError">
            {{ $t('vendors.upload.uploadError') }} <br />
            {{ $t('vendors.upload.file') }}: {{ uploadError.fileName }}<br />
            <router-link to="/vendors/list">{{ $t('common.back') }}</router-link>
          </p>
        </form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createResumable } from '@shared/external';
import { mapStores } from 'pinia';
import { useUserStore } from '../../stores/UserStore';

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: 'app',
  data() {
    return {
      uploadError: null,
      fileSizeError: false,
      currentStatus: null,
      uploadFieldName: 'filename[]',
      progressValue: 0,
    };
  },
  computed: {
    ...mapStores(useUserStore),

    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    progress() {
      return this.progressValue;
    },
    isOldBrowser() {
      return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
    },
  },
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadError = null;
    },
    save(fileList) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;

      this.imageUploading(this.userStore.selectedCompany.id, fileList)
        .then((response) => {
          this.currentStatus = STATUS_SUCCESS;
          this.$router.push({ name: 'List' });
        })
        .catch((err) => {
          console.error('Upload error', err);
          this.uploadError = err;
        });
    },

    filesChange(fieldName, fileList) {
      this.fileSizeError = false;

      // handle file changes
      if (!fileList.length) return;

      // save it
      this.save(fileList);
    },

    imageUploading(companyId, files) {
      return new Promise((resolve, reject) => {
        const r = createResumable(`${API_URL}/images/${companyId}/upload`);

        // Resumable.js isn't supported, fall back on a different method
        if (!r.support) {
          return reject($t('vendors.upload.uploadNotSupported'));
        }

        // Handle file add event
        r.on('filesAdded', (file) => {
          r.upload();
        });
        r.on('complete', () => {
          // // kolla om alla filer är klara och redirecta till startsidan
          return resolve();
        });
        r.on('error', function (error, message) {
          r.cancel();
          console.error('Error uploading file:', message?.fileName, error);
          return reject({ fileName: message?.fileName, message: message });
        });
        r.on('progress', () => {
          this.progressValue = Math.floor(r.progress(true) * 100);
        });

        r.addFiles(files);
      });
    },
  },
  mounted() {
    this.reset();
  },
};
</script>

<style lang="scss">
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: #ddd;
  color: black;
  min-height: 300px; /* minimum height */
  position: relative;
  cursor: pointer;
  flex-direction: column;
}

.dropbox:hover {
  background: #ccc; /* when mouse over to the drop zone, change color */
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  position: absolute;
  cursor: pointer;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
}

.progress-bar-container {
  width: 70%;
  margin: 0 auto;
}
</style>
